<template>
  <div class="container">
      <div class='title-container'>
          <h3 class="title">{{title}}</h3>
      </div>
      <div class='message-container'>
          <label for="message" class="messsage">{{message}}</label>
      </div>
      <div class="button-container">
          <button class="button-message" @click="hideModal"> Ok </button> 
      </div>
  </div>
</template>

<script>
export default {
  name: "MessagePopUp",
  props: ['modal', 'title', 'message', 'nameModal'],
  data() {
    return {};
  },
  methods: {
    hideModal: function() {
        this.modal.hide(this.nameModal);
    },
  }
};
</script>

<style scoped lang="less">
    .container { 
        margin: 25px;

        .button-container {
            margin: 25px 0;
            
            .button-message {
                font-weight: 500;
                padding: 12px 55px;
                font-size: 1.1rem;
                -webkit-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
                box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
                border-radius: 4px;
                border: 0;
                color: white;
                cursor: pointer;
                -webkit-transition: all 0.5s ease;
                transition: all 0.5s ease;
                background: #dc143d;
                margin: auto;
                display: block;
            }
        }
    }

</style>